/* eslint-disable react/no-unescaped-entities */
import { NavLink } from "react-router-dom";
import Navbar from "../components/dmb/Navbar";
import Footer from "../components/dmb/Footer";

const TABS = [
    { to: "/mentions-legales", label: "Mentions légales" },
    { to: "/confidentialite", label: "Politique de confidentialité" },
    { to: "/cookies", label: "Politique cookies" },
];

export default function LegalLayout({ kicker, title, lastUpdate, testid, children }) {
    return (
        <div data-testid={testid} className="bg-dmb-page">
            <Navbar />
            <main>
                <section className="bg-white border-b border-dmb-border">
                    <div className="container-dmb pt-12 pb-8 lg:pt-16 lg:pb-10 max-w-[920px]">
                        <div className="surtitre mb-3">{kicker}</div>
                        <h1>{title}</h1>
                        {lastUpdate && (
                            <p className="mt-4 text-[14px] text-dmb-muted-2">
                                Dernière mise à jour : {lastUpdate}
                            </p>
                        )}
                        <nav
                            aria-label="Navigation entre les pages légales"
                            data-testid="legal-tabs"
                            className="mt-8 flex flex-wrap gap-2 border-b border-dmb-border -mb-px"
                        >
                            {TABS.map((t) => (
                                <NavLink
                                    key={t.to}
                                    to={t.to}
                                    end
                                    data-testid={`legal-tab-${t.to.slice(1)}`}
                                    className={({ isActive }) =>
                                        `px-4 py-3 text-[14px] font-semibold border-b-2 transition-colors ${
                                            isActive
                                                ? "border-dmb-navy text-dmb-navy"
                                                : "border-transparent text-dmb-muted hover:text-dmb-navy"
                                        }`
                                    }
                                >
                                    {t.label}
                                </NavLink>
                            ))}
                        </nav>
                    </div>
                </section>

                <section className="section-pad">
                    <div className="container-dmb max-w-[920px] prose-legal">
                        {children}
                    </div>
                </section>
            </main>
            <Footer />

            <style>{`
                .prose-legal h2 {
                    font-size: 22px;
                    margin-top: 2.5rem;
                    margin-bottom: 1rem;
                    color: var(--dmb-navy);
                }
                .prose-legal p, .prose-legal li {
                    font-size: 15.5px;
                    line-height: 1.75;
                    color: var(--dmb-muted);
                }
                .prose-legal p { margin-bottom: 1rem; }
                .prose-legal ul { padding-left: 1.3rem; margin-bottom: 1rem; }
                .prose-legal li { margin-bottom: 0.4rem; }
                .prose-legal strong { color: var(--dmb-navy); font-weight: 600; }
                .prose-legal a { color: var(--dmb-green-dark); text-decoration: underline; text-underline-offset: 3px; }
                .prose-legal a:hover { color: var(--dmb-navy); }
                .prose-legal table {
                    width: 100%;
                    border-collapse: collapse;
                    margin: 1.5rem 0;
                    background: #fff;
                    border: 1px solid var(--dmb-border);
                    border-radius: 12px;
                    overflow: hidden;
                    display: block;
                    overflow-x: auto;
                    white-space: normal;
                }
                .prose-legal thead, .prose-legal tbody, .prose-legal tr { display: table; width: 100%; table-layout: fixed; }
                .prose-legal th, .prose-legal td {
                    padding: 14px 18px;
                    text-align: left;
                    font-size: 14.5px;
                    vertical-align: top;
                }
                .prose-legal th {
                    background: var(--dmb-page);
                    color: var(--dmb-navy);
                    font-weight: 600;
                    border-bottom: 2px solid var(--dmb-navy);
                }
                .prose-legal td { border-top: 1px solid var(--dmb-border-soft); color: var(--dmb-muted); }
                .prose-legal td:first-child { color: var(--dmb-navy); font-weight: 500; }
            `}</style>
        </div>
    );
}
